'use strict';

import controller from './c-input-money.controller';
const CInputMoneyComponent = {
  bindings: {
      name: '@',
      label: '@',
      ngModel: '=',
      ngDisabled: '=',
      ngRequired: '=',
      ngBlur: '&?',
      ngChange: '&?',
      placeholder: '@?',
      ngValidation: '@',
      ngMinvalue: '@',
      ngMaxvalue: '@',
      ngDecimals: '@'
  },
  require: {
    form: '^form',
  },
  template: `
     <div class="md-form-group">
      <label class="md-control-label" ng-class="{'requerido':$ctrl.ngRequired}" style="top:-1rem;font-size:11px;">{{$ctrl.label}}</label>
      <div class="input-group">
        <input ng-required="$ctrl.ngRequired"
               ng-disabled="$ctrl.ngDisabled"
               ng-readonly="$ctrl.ngReadonly"
               ng-model="$ctrl.ngModel"
               ng-maxlength="$ctrl.ngMaxlength"
               ng-placeholder="$ctrl.placeholder"
               ng-blur="$ctrl.ngBlur()"
               ng-change="$ctrl.ngChange()"
               name="{{$ctrl.name}}"
               type="text"
               numerico
               min="$ctrl.ngMinvalue"
               max="$ctrl.ngMaxvalue"
               decimals="$ctrl.ngDecimals"
               >
        <button type="button" class="btn btn-link p-0 m-0"><i class="fa fa-money" aria-hidden="true"></i></button>
      </div>
      <i class="md-bar" ng-class="{'error':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>
      <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">
        <div ng-message="required"> El campo es requerido. </div>
      </div>
    </div>`,
  controller

};

export default CInputMoneyComponent;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-input-money/c-input-money.component.js